import { useHistory } from "react-router-dom";
import styled from "styled-components";
import logo from "../images/logo.png";

const TitleCardSimple: React.FC<{
	showSubtitle?: boolean
}> = ({showSubtitle = false}) => {
	const history = useHistory();
	return (
		<TitleContainer
			onClick={() => history.push('/')}
		>
			{/* <Title><div>Your</div><div>Active</div><div>Games</div></Title> */}
			<div className="baner_container" style={{width:"450px", margin:"0 auto"}} >
				<div className="logo">
					<img style={{width:"100%",marginBottom:"10px"}} src={logo} alt="Logo" />
				</div>
				<div className="ban_list">
					<ul style={{padding:"0"}}>
						<li style={{fontSize:"14px",lineHeight:"1.2",marginBottom:"12px"}}>Play in Matches and Tournaments by challenging fellow players.</li>
						<li style={{fontSize:"14px",lineHeight:"1.2",marginBottom:"12px"}}>Ratings are affected by wins and losses so your play matters.</li>
						<li style={{fontSize:"14px",lineHeight:"1.2",marginBottom:"12px"}}>So Compete, Have Fun, Play Fair & Get Active</li>
					</ul>
				</div>
			</div>
			
			{/* {showSubtitle && <Subtitle>Compete by challenging fellow players and playing in tournaments. Click About for more information</Subtitle>} */}
		</TitleContainer>
	);
}

export default TitleCardSimple;

const TitleContainer = styled.div`
	color: var(--ion-color-accent-two);
	font-family: var(--heading-font);
	
`;

const Title = styled.div`
	font-size: clamp(30px, 20vw, 35px);
	font-weight: 600;
	display: flex;
	flex-direction: column;
	align-items: start;
	justify-content: start;
	margin: 0 0 8px;
	& div {
		margin: -4px 0;
	}
`;

const Subtitle = styled.div`
	font-size: clamp(20px, 5vw, 20px);
	font-weight: normal;
`;